import create from 'zustand';
import { IPackage, IPackagePrice, ISubscribedInfo } from '@root/types/package';
import { EPayMode } from '@root/constant';
import { isInIosApp } from '@root/shared';

export interface IState {
  packageData: IPackage;
  selectedPrice: IPackagePrice;
  subscribedInfo: ISubscribedInfo;
  updateTime: number;
  payMode: EPayMode | 'promotions'; // 活动页的套餐数据
  setPackage: (v: IPackage, payMode: EPayMode | 'promotions') => void;
  setSelectedPrice: (v: IPackagePrice) => void;
  updateSubscribedInfo: (v: Partial<ISubscribedInfo>) => void;
  resetInitData: () => void;
}

const useDefaultPackageState = create<IState>((set) => ({
  packageData: {} as IPackage,
  selectedPrice: {} as IPackagePrice,
  subscribedInfo: {} as ISubscribedInfo,
  payMode: isInIosApp ? EPayMode.ApplePay : EPayMode.PayPal,
  updateTime: 0,
  setPackage: (packageData, payMode) => {
    return set(() => {
      return {
        updateTime: new Date().getTime(),
        packageData,
        payMode,
      };
    });
  },
  setSelectedPrice: (selectedPrice) => {
    return set(() => {
      return {
        selectedPrice,
      };
    });
  },
  updateSubscribedInfo: (subscribedInfo) => {
    return set((state) => {
      return {
        subscribedInfo: {
          ...state.subscribedInfo,
          ...subscribedInfo,
        },
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        packageData: {} as IPackage,
        selectedPrice: {} as IPackagePrice,
        subscribedInfo: {} as ISubscribedInfo,
        updateTime: 0,
      };
    });
  },
}));

export default useDefaultPackageState;
